import React from 'react';
import './SavedCardsList.scss';

const SavedCardsList = props => {
  const {
    usersSavedCardsList,
    deleteUserCard,
    userEmail,
    dataLocale: { DELETE_BTN },
  } = props;
  return (
    <div className="row-fluid saved-card-list">
      {usersSavedCardsList.length &&
        usersSavedCardsList.map((savedCard, index) => {
          return (
            <div key={index} className="col-lg-7 col-md-7 col-sm-7 margin-t10">
              <div
                className={`col-lg-10 col-md-10 col-sm-10 user-cards-image padding-0 ${
                  savedCard.expired ? 'user-expired-cards' : ''
                }`}
              >
                <div className="col-lg-2 col-md-2 col-sm-2 text-left padding-l0 user-card-image">
                  <div
                    className={`save-payment-card-image ${
                      savedCard.cardBrand ? savedCard.cardBrand.toLowerCase() : ''
                    }`}
                  ></div>
                </div>
                <div className="col-lg-10 col-md-10 col-sm-10 padding-t15 padding-b15 padding-r0 padding-l0 user-card-deatils">
                  <div className="col-lg-12 col-md-12 col-sm-12 padding-b5 padding-l0 user-saved-card-name">
                    <div className="col-lg-6 col-md-6 col-sm-6 text-left fs13 user-saved-card-type padding-l0">
                      {savedCard.cardBrand} {savedCard.cardMode}
                    </div>
                    <div
                      className="col-lg-6 col-md-6 col-sm-6 padding-r0 text-right"
                      onClick={() => deleteUserCard(savedCard.cardToken, userEmail)}
                    >
                      <img
                        alt={DELETE_BTN}
                        className="cursor-pointer"
                        src="https://static.lenskart.com/media/desktop/img/delete.png"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 padding-l0">
                    <div className="col-lg-6 col-md-6 col-sm-6 text-left fs13 padding-l0 user-saved-card-number">
                      {savedCard.number}
                    </div>
                    <div
                      className={`col-lg-6 col-md-6 col-sm-6 text-right padding-l0 padding-r0 fs12 ${
                        savedCard.expired ? 'user-card-expired' : 'user-card-expiry-date'
                      }`}
                    >
                      {`Card ${savedCard.expired ? 'expired' : 'expires'} in ${
                        savedCard.expiryMonth
                      }/${savedCard.expiryYear}`}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default SavedCardsList;
